import { IEditGameCategoryState } from './editGameCategoryContext';
import { EditGameCategoryActionTypes, TEditGameCategoryAction } from './editGameCategoryActions';

export const editGameCategoryReducer = (
	state: IEditGameCategoryState,
	action: TEditGameCategoryAction,
): IEditGameCategoryState => {
	switch (action.type) {
		case EditGameCategoryActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetch,
			};
		case EditGameCategoryActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditGameCategoryActionTypes.SET_ALL_DATA:
			return {
				...state,
				categoryID: action.payload.categoryID,
				name: action.payload.name,
				IDsSelectedLanguages: action.payload.IDsSelectedLanguages,
				translations: action.payload.translations,
			};
		case EditGameCategoryActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case EditGameCategoryActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case EditGameCategoryActionTypes.SET_FETCHED_LANGUAGES:
			return {
				...state,
				fetchedLanguages: action.payload.languages,
			};
		case EditGameCategoryActionTypes.SET_IDs_LANGUAGES:
			return {
				...state,
				IDsSelectedLanguages: action.payload.IDsLanguages,
			};
		case EditGameCategoryActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.data,
			};
		case EditGameCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditGameCategoryActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.translationTab,
			};
		case EditGameCategoryActionTypes.SET_TRANSLATION_FIELDS:
			return {
				...state,
				translations: action.payload.updatedTranslations,
			};
		case EditGameCategoryActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.updatedTranslations,
			};
		case EditGameCategoryActionTypes.RESET_FIELDS:
			return {
				...state,
				name: '',
				fetchedLanguages: [],
				IDsSelectedLanguages: [],
				dataForSubmit: null,
				translations: [],
			};
		default:
			return state;
	}
};
